<template>
  <div id="box" class="column">
    <div id="content" class="column">
      <div id="content-title" class="column">
        <span>姓名：{{UserData.name}}</span>
        <span>{{UserData.bir}}</span>
      </div>
      <div id="content-title-bottom">请到操场或财务处缴费报道</div>
      <div id="content-list-title">基本信息</div>
      <div id="content-list" class="column">
        <div class="content-list-content">
          <div class="content-list-content-left">学号</div>
          <div class="content-list-content-right">21200</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">院系</div>
          <div class="content-list-content-right active">材料工程系</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">班级</div>
          <div class="content-list-content-right">专升本1</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">住宿</div>
          <div class="content-list-content-right">中区3号楼</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">学费</div>
          <div class="content-list-content-right">欠费</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">住宿费</div>
          <div class="content-list-content-right">欠费</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">学费缴纳明细</div>
          <div class="content-list-content-right">应缴，实缴</div>
        </div>
        <div class="content-list-content">
          <div class="content-list-content-left">住宿费缴纳明细</div>
          <div class="content-list-content-right">应缴，实缴</div>
        </div>
      </div>
    </div>
    <!-- <div id="content2" v-else-if="tableData.status=='noUser||userAbnormal'">
    暂无人员信息
  </div>
  <div id="content2" v-else-if="tableData.status=='noLeave'">
  你不在请假时间之内
  </div>
<div id="content3" v-else-if="tableData.status=='dormError'">
    你不住在该宿舍
  </div> -->
  </div>
</template>
<script>
import { accountScan } from "@/api/zhicheng.js";
export default {
  name: "App",
  data() {
    return {
      type: "",
      location: "",
      tableData: {},
      Query: {},
      UserData:{name:"张三",tel:"164654985",bir:'2020-10'}
    };
  },
  async created() {
    this.Query = this.$route.query;
    if (!this.Query.location) return;
    console.log("路由参数", Query);
    this.handPersonalDetailList();
  },
  methods: {
    handPersonalDetailList() {
      // this.$router.push({
      //   url: "/pages?name=1234564",
      // });
      let data = {
        type: this.type,
        location: this.location,
      };
      accountScan(this.Query).then((res) => {
        this.UserData = res.data;
      });
    },
  },
};
</script>

<style lang='scss' scoped>
* {
  margin: 0;
  padding: 0;
}
.column {
  display: flex;
  flex-direction: column;
  /* flex-wrap:wrap; */
}
#box {
  width: 100vw;
  height: 100vh;
  background: #edf4fa;
}
#content {
  width: 90%;
  height: 80%;
  background: #fff;
  border-radius: 6px;
  margin-top: 5%;
  margin-left: 5%;
}
#content-title {
  padding-top: 5%;
}
#content-title > span {
  font-size: 16px;
  padding-left: 25%;
  line-height: 1.8;
}
#content-title > span:first-child {
  font-weight: 300;
}
#content-title > span:last-child {
  font-weight: 700;
  color: red;
}
#content-title-bottom {
  font-weight: 600;
  color: red;
  font-size: 16px;
  margin-left: 10px;
}

#content-list {
  padding-top: 5%;
  padding-left: 5%;
}
#content-list-title {
  font-size: 18px;
  font-weight: 300;
  width: 100%;
  padding-left: 5%;
}
.content-list-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 3% 0;
}
.content-list-content-left {
  width: 28%;
  border-right: 1px solid #ccc;
  color: #a6bedb;
}
.content-list-content-right {
  width: 60%;
  font-weight: 400;
  font-size: 16px;
  padding-left: 7%;
}
</style>